<template>
  <div>
    <div v-if="room">
      <div class="has-background-dark py-1" style="height: 36px;">
        <TopNavComponent v-bind:user="user" v-bind:room="room" v-bind:roomId="roomId" />
      </div>
      <div style="max-width: 400px; margin: 0 auto;" class="pt-2">
        <SideComponent
          style="height: 50px;"
          v-bind:state="state"
          v-bind:user="topUser"
          v-bind:isTop="true"
          v-bind:defaultPosition="0"
          v-bind:clientPosition="topPosition"
          v-bind:clientState="clientState"
          v-bind:emoji="topEmoji"
        />
        <div class="level is-mobile px-2 mt-2 mb-0" style="height: 290px;">
          <SideComponent
            style="width: 15%;"
            v-bind:state="state"
            v-bind:user="leftUser"
            v-bind:isTop="false"
            v-bind:defaultPosition="3"
            v-bind:clientPosition="leftPosition"
            v-bind:clientState="clientState"
            v-bind:emoji="leftEmoji"
          />
          <CenterComponent
            v-bind:game="room.game"
            v-bind:user="user"
            v-bind:state="state"
            v-bind:clientState="clientState"
            v-bind:topPosition="topPosition"
            v-bind:rightPosition="rightPosition"
            v-bind:leftPosition="leftPosition"
            v-bind:bottomPosition="bottomPosition"
          />
          <SideComponent
            style="width: 15%;"
            v-bind:state="state"
            v-bind:user="rightUser"
            v-bind:isTop="false"
            v-bind:defaultPosition="1"
            v-bind:clientPosition="rightPosition"
            v-bind:clientState="clientState"
            v-bind:emoji="rightEmoji"
          />
        </div>
        <BottomComponent
          class="mt-4"
          v-bind:state="state"
          v-bind:user="user"
          v-bind:bottomUser="bottomUser"
          v-bind:defaultPosition="2"
          v-bind:game="room.game"
          v-bind:clientState="clientState"
          v-bind:emoji="bottomEmoji"
        />
      </div>
      <div
        class="mt-4"
        v-if="state == 2 || (state == 3 && room.game.round == 1)"
        style="max-width: 400px; margin: 0 auto;"
      >
        <BidComponent v-bind:bids="room.game.bids"></BidComponent>
      </div>
      <div class="mt-4" v-if="state == 3 || state == 4" style="max-width: 400px; margin: 0 auto;">
        <div v-if="room.game && room.game.rounds && room.game.round > 1">
          <RoundComponent
            v-bind:round="room.game.rounds[room.game.round - 2]"
            v-bind:roundWinner="room.game.roundWinners[room.game.round - 2]"
          ></RoundComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
import socketStore from "@/service/socketStore";

import BottomComponent from "@/components/BottomComponent.vue";
import CenterComponent from "@/components/CenterComponent.vue";
import SideComponent from "@/components/SideComponent.vue";
import BidComponent from "@/components/BidComponent.vue";
import RoundComponent from "@/components/RoundComponent.vue";
import TopNavComponent from "@/components/TopNavComponent.vue";
var t,l,r,b;
export default {
  name: "Room",
  components: {
    BottomComponent,
    CenterComponent,
    SideComponent,
    BidComponent,
    RoundComponent,
    TopNavComponent,
  },
  props: {
    roomId: String,
  },
  data: () => {
    return {
      socket: null,
      state: 0,
      room: {},
      user: {},
      topUser: {},
      rightUser: {},
      leftUser: {},
      bottomUser: {},
      userPosition: -1, // no selected user position
      clientState: 0,
      error: "",
      topPosition: 0,
      rightPosition: 0,
      leftPosition: 0,
      bottomPosition: 0,
      topEmoji: "",
      leftEmoji: "",
      rightEmoji: "",
      bottomEmoji: ""
    };
  },
  methods: {
    checkAI() {
      if(this.room && this.room.game && this.room.game.currentTurn > -1) {
        var user = this.room.users.find(p => p.position == this.room.game.currentTurn);
        if(user.userId.includes("AI_")) {
          if(this.room.state == 2) {
            socketStore.emit("set_ai_bid", this.roomId);
          } else if(this.room.state == 3) {
            socketStore.emit("set_ai_move", this.roomId);
          }
        }
      }
    }
  },
  created() {
    let params = `roomId=${this.roomId}`;
    // The game server shares the Narabu app's origin, namespaced under
    // /kanto-bridge/socket.io. In development (vue serve) it connects to the
    // Narabu dev server; override with VUE_APP_SERVER_URL if needed.
    const opts = { query: params, path: "/kanto-bridge/socket.io" };
    const serverUrl =
      process.env.VUE_APP_SERVER_URL ||
      (process.env.NODE_ENV == "development" ? "http://localhost:3000" : "");
    if (serverUrl) {
      this.socket = io(serverUrl, opts);
    } else {
      this.socket = io(opts);
    }
    socketStore.setSocketStore(this.socket, this.roomId);

    let storedUser = localStorage.getItem(this.roomId);
    if (storedUser) {
      // Rejoin room
      var sUser = JSON.parse(storedUser);
      this.user = sUser;
      socketStore.setUserId(sUser.userId);
      socketStore.emit("join_room", sUser.username);
    }

    this.socket.on("room_update", (data) => {
      if (data) {
        setTimeout(() => {}, 2000);
      }

      this.room = data;
      this.state = this.room.state;

      // Set the top, left, right, bottom positions
      this.bottomPosition = 2;
      var tempUser = this.room.users.find((p) => p.userId == this.user.userId);
      if (tempUser) {
        this.bottomPosition = tempUser.position > -1 ? tempUser.position : 2;
      }

      this.rightPosition = (this.bottomPosition + 3) % 4;
      this.topPosition = (this.bottomPosition + 2) % 4;
      this.leftPosition = (this.bottomPosition + 1) % 4;

      this.rightUser = this.room.users.find(
        (p) => p.position == this.rightPosition
      );
      this.topUser = this.room.users.find(
        (p) => p.position == this.topPosition
      );
      this.leftUser = this.room.users.find(
        (p) => p.position == this.leftPosition
      );
      this.bottomUser = this.room.users.find(
        (p) => p.position == this.bottomPosition
      );
      // check if next turn is AI, proactively get room
      this.checkAI();
    });

    this.socket.on("user_update", (data) => {
      this.user = data;
      this.userPosition = this.user.position;
      if (this.userPosition == -1) {
        this.clientState = 1;
      } else {
        this.clientState = 2;
      }
    });

    this.socket.on("error", (data) => {
      this.error = data;
      console.error(data);
    });

    this.socket.on("send_emoji", (data) => {
      // emoji array
      var timeoutTime = 2500;
      if (data.position > -1 && data.position < 4) {
        if (data.position == this.topPosition) {
          
          clearTimeout(t);
          this.topEmoji = data.emoji;
          t = setTimeout(() => (this.topEmoji = ""), timeoutTime);

        } else if (data.position == this.leftPosition) {
          
          clearTimeout(l);
          this.leftEmoji = data.emoji;
          l = setTimeout(() => (this.leftEmoji = ""), timeoutTime);

        } else if (data.position == this.rightPosition) {
          
          clearTimeout(r);
          this.rightEmoji = data.emoji;
          r = setTimeout(() => (this.rightEmoji = ""), timeoutTime);

        } else if (data.position == this.bottomPosition) {
          
          clearTimeout(b);
          this.bottomEmoji = data.emoji;
          b = setTimeout(() => (this.bottomEmoji = ""), timeoutTime);
        }
      }
    });
  },
};
</script>

<style>
</style>
